import cors from 'cors';
const { NODE_ENV } = process.env;
export const corsHandleOrigin = (origin = '', callback) => {
    // Disable CORS for local dev
    if (NODE_ENV === 'development') {
        callback(null, true);
        return;
    }
    // Disable CORS if no origin was passed
    if (!origin.length) {
        callback(null, true);
        return;
    }
    // Our supported CORS cases
    const tests = [
        /^http[s]*:\/\/(localhost|[\w]+.navlocal.io|local.nav.com)+(:[\d]+)*$/,
        /^http[s]*:\/\/.+.(nav.(engineering|com)+)$/i, // https://regex101.com/r/XVukCe/4
    ];
    const isOriginAllowed = tests.some((test) => !!origin.match(test));
    if (isOriginAllowed) {
        callback(null, true);
        return;
    }
    callback(new Error(`Invalid origin: ${origin}`), false);
};
export const corsConfig = cors({ origin: corsHandleOrigin, maxAge: 86400 }); // allow the preflight request to be cached for 24 hours
//# sourceMappingURL=cors-config.js.map